import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { DayPicker } from 'react-day-picker';
import { calendarComponents } from './calendar_components';
import { calendarStyles } from './calendar_styles';
import { toDate, toPlainDate } from '../date_utils';
export const adaptBaseProps = (props) => (Object.assign(Object.assign({}, props), { defaultMonth: props.defaultMonth && toDate(props.defaultMonth), fromDate: props.startDate && toDate(props.startDate), toDate: props.endDate && toDate(props.endDate) }));
export const DateCalendar = (_a) => {
    var { value, onChange, required } = _a, rest = __rest(_a, ["value", "onChange", "required"]);
    const onSelect = (inputDate) => {
        onChange(inputDate && toPlainDate(inputDate));
    };
    const baseProps = adaptBaseProps(rest);
    return (_jsx(DayPicker, Object.assign({}, baseProps, { defaultMonth: baseProps.defaultMonth || (value && toDate(value)), mode: 'single', required: required, selected: value && toDate(value), onSelect: onSelect, classNames: calendarStyles, components: calendarComponents })));
};
//# sourceMappingURL=calendar_date.js.map